export default __webpack_public_path__ + "static/media/wSweats_1_c2.1a023d6b.jpeg";